import { useTranslation } from 'react-i18next';
import { SvgIcon } from '@/components';

import styles from './CreditsBenefits.module.sass';

type Benefit = {
  icon: string;
  titleKey: string;
  textKey?: string;
};

const BENEFITS: Benefit[] = [
  {
    icon: 'scan-verify',
    titleKey: 'translation.credits_benefit_kyt_title',
    textKey: 'translation.credits_benefit_kyt_text',
  },
  {
    icon: 'investigations',
    titleKey: 'translation.credits_benefit_investigations_title',
    textKey: 'translation.credits_benefit_investigations_text',
  },
  {
    icon: 'connect',
    titleKey: 'translation.credits_benefit_connections_title',
    textKey: 'translation.credits_benefit_connections_text',
  },
  { icon: 'shield', titleKey: 'translation.credits_benefit_sanctions_title' },
  { icon: 'trend-up', titleKey: 'translation.credits_benefit_analytics_title' },
  {
    icon: 'notification',
    titleKey: 'translation.credits_benefit_alerting_title',
  },
  { icon: 'pdf', titleKey: 'translation.credits_benefit_pdf_title' },
];

export const CreditsBenefits = () => {
  const { t } = useTranslation();

  return (
    <aside className={styles.panel}>
      <h3 className={styles.title}>
        {t('translation.credits_benefits_title')}
      </h3>

      <ul className={styles.list}>
        {BENEFITS.map(({ icon, titleKey, textKey }) => (
          <li key={titleKey} className={styles.item}>
            <span className={styles.iconTile} aria-hidden="true">
              <SvgIcon name={icon} className={styles.icon} />
            </span>
            <div className={styles.body}>
              <div className={styles.itemTitle}>{t(titleKey)}</div>
              {textKey && <div className={styles.itemText}>{t(textKey)}</div>}
            </div>
          </li>
        ))}
      </ul>
    </aside>
  );
};
